import type { DifficultyPreset } from '../../simulation/ai/difficulty';
import easyEmblemUrl from '../../assets/menu/difficulty-easy.webp?url';
import normalEmblemUrl from '../../assets/menu/difficulty-normal.webp?url';
import hardEmblemUrl from '../../assets/menu/difficulty-hard.webp?url';

export interface DifficultySelectDeps {
  initial?: DifficultyPreset;
  onChange(preset: DifficultyPreset): void;
  /** Document used to create elements (for testability without a global `document`). */
  doc?: Document;
}

export function createDifficultySelect(deps: DifficultySelectDeps): HTMLElement {
  const doc = deps.doc ?? document;
  const root = doc.createElement('fieldset');
  root.className = 'main-menu-difficulty';
  root.setAttribute('data-testid', 'difficulty-select');
  const legend = doc.createElement('legend');
  legend.textContent = 'Сложность';
  root.appendChild(legend);
  const presets: DifficultyPreset[] = ['easy', 'normal', 'hard'];
  const labels: Record<DifficultyPreset, string> = {
    easy: 'Лёгкая',
    normal: 'Обычная',
    hard: 'Сложная',
  };
  const emblems: Record<DifficultyPreset, string> = {
    easy: easyEmblemUrl,
    normal: normalEmblemUrl,
    hard: hardEmblemUrl,
  };
  for (const p of presets) {
    const label = doc.createElement('label');
    label.className = 'main-menu-difficulty-option';
    label.dataset.difficulty = p;
    const input = doc.createElement('input');
    input.type = 'radio';
    input.name = 'difficulty';
    input.value = p;
    input.setAttribute('data-testid', `difficulty-${p}`);
    if (p === (deps.initial ?? 'normal')) input.checked = true;
    input.addEventListener('change', () => {
      if (input.checked) deps.onChange(p);
    });
    const emblem = doc.createElement('img');
    emblem.className = 'main-menu-difficulty-emblem';
    emblem.src = emblems[p];
    emblem.alt = '';
    emblem.width = 64;
    emblem.height = 64;
    emblem.draggable = false;
    label.appendChild(input);
    label.appendChild(emblem);
    label.appendChild(doc.createTextNode(' ' + labels[p]));
    root.appendChild(label);
  }
  return root;
}
